import React from 'react'
import { useFormContext } from 'react-hook-form'

export const SubmitButton = () => {
  const { formState } = useFormContext()
  const { isSubmitting } = formState

  return (
    <button
      type="submit"
      disabled={isSubmitting}
      className='payment-button'
      style={{ margin: `1em auto`, display: `block` }}
    >
      <span>Solicitar Retiro</span>
    </button>
  )
}
